import { render, staticRenderFns } from "./IrRefund.vue?vue&type=template&id=6abc919c&"
import script from "./IrRefund.vue?vue&type=script&lang=js&"
export * from "./IrRefund.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports